import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./assets/logo.png";
import PRODUCTS from "./data/products.json";
import { useCart } from "./contexts/CartContext";
import { useTheme } from "./contexts/ThemeContext";
import { useUser } from "./contexts/UserContext";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { Heart } from "lucide-react";
import { ShoppingCart } from "lucide-react";
import heroImgDesktop from "./assets/hero-products-desktop.jpg";
import heroImgMobile from "./assets/hero-products-mobile.jpg";



export default function BubbleButterSite() {
  const menuRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
  function handleClickOutside(event) {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  }

  function handleScroll() {
    setMenuOpen(false);
  }

  if (menuOpen) {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
    window.removeEventListener("scroll", handleScroll);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    window.removeEventListener("scroll", handleScroll);
  };
}, [menuOpen]);

  

useEffect(() => {
  function handleClickOutside(event) {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  }

  if (menuOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [menuOpen]);



  
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { darkMode, setDarkMode } = useTheme();
  const navigate = useNavigate();
  const { itemCount, cart, addItem, removeItem, changeQty } = useCart();
  const { userData, loading } = useUser();

  const [favorites, setFavorites] = useState(() => {
    try {
      const raw = localStorage.getItem("bb_fav_v1");
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("bb_fav_v1", JSON.stringify(favorites));
    } catch {}
  }, [favorites]);

  const BESTSELLERS = PRODUCTS.filter((p) => p.bestseller);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
      setShowDropdown(false);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  function qtyInCart(productId) {
    const found = cart.find((p) => p.id === productId);
    return found?.qty || 0;
  }

  const toggleFavorite = (id) => {
    setFavorites((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleAdd = (product) => addItem(product, 1);
  const handleDecrement = (productId) => {
    const q = qtyInCart(productId);
    if (q <= 1) removeItem(productId);
    else changeQty(productId, -1);
  };
  const handleIncrement = (product) => addItem(product, 1);

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gradient-to-b from-pink-100 to-white dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-200">

        {/* HEADER */}
        <header className="w-full py-3 shadow bg-white/70 dark:bg-gray-900/70 backdrop-blur-lg sticky top-0 z-50 border-b border-gray-200/40 dark:border-gray-700/40">
          <div className="max-w-6xl mx-auto flex items-center justify-between px-4">
            {/* LOGO */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate("/")}>
              <img src={logo} alt="Bubble Butter Logo" className="h-14 md:h-16 object-contain" />
              <h1 className="text-xl md:text-2xl font-bold text-pink-600 dark:text-pink-300">Bubble Butter</h1>
            </div>

            {/* DESKTOP NAVBAR */}
            <div className="hidden md:flex items-center gap-6">
              <nav className="flex gap-6 text-lg font-medium">
                <button
                  onClick={() => navigate("/products")}
                  className="hover:text-pink-600 dark:hover:text-pink-300"
                >
                  Products
                </button>
               
                <a href="#about" className="hover:text-pink-600 dark:hover:text-pink-300">About</a>
                {/* Support Dropdown (Desktop) */}

                <div className="relative group inline-block">
                  <button className="hover:text-pink-600 dark:hover:text-pink-300 flex items-center gap-1">
                    Support ▾
                  </button>

                  <div className="absolute left-0 hidden group-hover:block bg-white dark:bg-gray-900 shadow-lg rounded-md py-2 mt-0 w-44 z-50 pt-2">
                    <button
                      onClick={() => navigate("/contact")}
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                      Contact
                    </button>

                    <button
                      onClick={() => navigate("/track-order")}
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                      Track Order
                    </button>
                  </div>
                </div>



              </nav>

              {!loading && userData?.role === "admin" && (
                <button
                  onClick={() => navigate("/admin")}
                  className="px-3 py-2 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-sm font-semibold text-black"
                >
                  ⚙️ Admin
                </button>
              )}

              {!userData ? (
                <button
                  onClick={() => navigate("/login")}
                  className="px-4 py-2 bg-pink-500 text-white rounded-xl shadow hover:bg-pink-600 transition"
                >
                  Login
                </button>
              ) : (
                <div className="relative" ref={dropdownRef}>
                  <button
                    className="px-3 py-2 bg-gray-200 dark:bg-gray-700 rounded-xl text-sm"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    {userData?.name || "User"} ▼
                  </button>
                  {showDropdown && (
                    <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-800 rounded-xl shadow-lg p-2 border border-gray-200 dark:border-gray-700 z-50">
                      <button className="w-full text-left px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
                        onClick={() => { navigate("/profile"); setShowDropdown(false); }}>
                        Profile
                      </button>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-3 py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}

              <button onClick={() => navigate("/cart")} className="relative p-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white">
                🛒
                {itemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs px-2 rounded-full">{itemCount}</span>
                )}
              </button>

              <button onClick={() => setDarkMode(!darkMode)} className="p-2 rounded-lg bg-gray-200 dark:bg-gray-700">{darkMode ? "🌞" : "🌙"}</button>
            </div>

            {/* MOBILE MENU BUTTON */}
            <button className="md:hidden text-pink-600 text-3xl" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
          </div>
        </header>

        {/* MOBILE MENU */}
        {menuOpen && (
          <div
            ref={menuRef}
            className="md:hidden fixed top-0 left-0 right-0 bg-white dark:bg-gray-900 shadow-lg border-b border-gray-200 dark:border-gray-700 z-50 max-h-screen overflow-y-auto"
          >

            <nav className="flex flex-col px-4 py-3 gap-3 text-lg font-medium">
              <button
                onClick={() => { navigate("/products"); setMenuOpen(false); }}
                className="text-left hover:text-ppink-600 dark:hover:text-pink-300"
              >
                Products
              </button>


              <a href="#about" className="hover:text-pink-600 dark:hover:text-pink-300" onClick={() => setMenuOpen(false)}>About</a>
              <button
                onClick={() => { navigate("/contact"); setMenuOpen(false); }}
                className="text-left hover:text-pink-600 dark:hover:text-pink-300"
              >
                Contact
              </button>
              <button
                onClick={() => { navigate("/track-order"); setMenuOpen(false); }}
                className="text-left hover:text-pink-600 dark:hover:text-pink-300"
              >
                Track Order
              </button>



              {/* First Row: Login / Logout / Username */}
              <div className="flex flex-row gap-2 flex-wrap">
                {!loading && !userData && (
                  <button
                    onClick={() => { navigate("/login"); setMenuOpen(false); }}
                    className="px-4 py-2 bg-pink-500 text-white rounded-xl shadow hover:bg-pink-600 transition flex-1 text-center"
                  >
                    Login
                  </button>
                )}
                {!loading && userData && (
                  <>
                    <div className="flex-1 px-3 py-2 bg-gray-200 dark:bg-gray-700 rounded-xl text-center">
                      {userData?.name}
                    </div>
                    <button
                      onClick={() => { handleLogout(); setMenuOpen(false); }}
                      className="flex-1 px-3 py-2 bg-pink-500 text-white rounded-xl hover:bg-pink-600 transition text-center"
                    >
                      Logout
                    </button>
                  </>
                )}
              </div>

              {/* ADMIN BUTTON — added here */}
              {!loading && userData?.role === "admin" && (
                <button
                  onClick={() => { navigate("/admin"); setMenuOpen(false); }}
                  className="px-4 py-2 bg-yellow-500 text-black font-semibold rounded-xl shadow hover:bg-yellow-600 transition w-full text-center"
                >
                  ⚙️ Admin
                </button>
              )}

              {/* Second Row: Cart + Theme Toggle */}
              <div className="flex flex-row gap-2 mt-2">
                <button
                  onClick={() => { navigate("/cart"); setMenuOpen(false); }}
                  className="relative flex-1 px-3 py-2 rounded-lg bg-pink-600 text-white text-center"
                >
                  🛒
                  {itemCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs px-2 rounded-full">
                      {itemCount}
                    </span>
                  )}
                </button>

                <button
                  onClick={() => setDarkMode(!darkMode)}
                  className="flex-1 px-3 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-center"
                >
                  {darkMode ? "🌞" : "🌙"}
                </button>
              </div>
            </nav>
          </div>
        )}


        {/* HERO SECTION */}
        <section className="relative overflow-hidden font-[Poppins]">
          {/* ================= MOBILE HERO ================= */}
          <div className="relative md:hidden h-[58vh] overflow-hidden">
            {/* Background image */}
            <img
              src={heroImgMobile}
              alt="Bubble Butter Handmade Products"
              className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            <div
              className="
                absolute inset-0
                bg-gradient-to-b
                from-white/20 via-white/10 to-transparent
                dark:from-black/65 dark:via-black/45 dark:to-black/20
              "
            />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center text-center pt-4 px-4">
              <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">
                Handmade Beauty
              </h1>

              <h2
                className="
                  mt-2 font-serif italic text-2xl
                  text-[#a8742a]
                  dark:text-[#f1c97a]
                "
              >
                Pure, Natural & Skin-Loving
              </h2>

              <p
                className="
                  mt-3 text-sm text-gray-700
                  dark:text-gray-200
                  max-w-xs
                "
              >
                Thoughtfully crafted soaps, candles, perfumes & skincare.
              </p>

              <button
                onClick={() => navigate("/products")}
                className="
                  mt-5 px-7 py-3 rounded-full text-sm font-semibold text-white
                  bg-gradient-to-r from-pink-500 to-orange-400 shadow-lg
                "
              >
                Explore Products
              </button>

              {/* CALLOUT STRIP */}
              <div
                className="
                  mt-3 mx-auto
                  px-3 py-3
                  rounded-2xl
                  bg-white/85 dark:bg-black/65
                  backdrop-blur-md
                  shadow-md
                  w-full max-w-[92%]
                  box-border
                "
              >
                <div className="grid grid-cols-3 items-center text-center">
                  {/* Item 1 */}
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-green-600 text-lg">🌿</span>
                    <span className="text-xs leading-tight text-gray-800 dark:text-white">
                      <strong>100%</strong>
                      <br />
                      Handmade
                    </span>
                  </div>

                  {/* Item 2 */}
                  <div className="flex items-center justify-center gap-2 border-x border-gray-300/60 dark:border-white/25 px-2">
                    <span className="text-teal-500 text-lg">🧪</span>
                    <span className="text-xs leading-tight text-gray-800 dark:text-white">
                      No Harsh
                      <br />
                      Chemicals
                    </span>
                  </div>

                  {/* Item 3 */}
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-pink-500 text-lg">🐰</span>
                    <span className="text-xs leading-tight text-gray-800 dark:text-white">
                      Cruelty
                      <br />
                      Free
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= DESKTOP HERO ================= */}
          <div className="relative hidden md:flex min-h-[82vh] overflow-hidden pt-10">
            {/* Background image */}
            <img
              src={heroImgDesktop}
              alt="Bubble Butter Handmade Products"
              className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            <div
              className="
                absolute inset-0
                bg-gradient-to-r
                from-white/60 via-white/35 to-transparent
                dark:from-black/70 dark:via-black/50 dark:to-transparent
              "
            />

            {/* Content */}
            <div className="relative z-10 flex w-full justify-center px-6">
              <div className="max-w-xl text-center">
                <h1 className="text-5xl font-extrabold text-gray-900 dark:text-white tracking-tight">
                  Handmade Beauty
                </h1>

                <h2
                  className="
                    mt-3 font-['Playfair_Display'] italic text-4xl
                    text-[#a8742a]
                    dark:text-[#f1c97a]
                  "
                >
                  Pure, Natural & Skin-Loving
                </h2>

                <p className="mt-4 text-lg text-gray-700 dark:text-gray-200 mx-auto max-w-md">
                  Thoughtfully crafted soaps, candles, perfumes & skincare.
                </p>

                <button
                  onClick={() => navigate("/products")}
                  className="
                    mt-7 px-10 py-4 rounded-full text-lg font-semibold text-white
                    bg-gradient-to-r from-pink-500 to-orange-400
                    shadow-lg hover:scale-105 transition
                  "
                >
                  Explore Products
                </button>

                {/* CALLOUT STRIP */}
                <div
                  className="
                    mt-8 mx-auto
                    px-6 py-4
                    rounded-full
                    bg-white/85 dark:bg-black/65
                    backdrop-blur-md
                    shadow-md
                    max-w-lg
                  "
                >
                  <div className="grid grid-cols-3 items-center text-center">
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-green-600 text-lg">🌿</span>
                      <span className="text-sm leading-tight text-gray-800 dark:text-white">
                        <strong>100%</strong>
                        <br />
                        Handmade
                      </span>
                    </div>

                    <div className="flex items-center justify-center gap-2 border-x border-gray-300/60 dark:border-white/25 px-3">
                      <span className="text-teal-500 text-lg">🧪</span>
                      <span className="text-sm leading-tight text-gray-800 dark:text-white">
                        No Harsh
                        <br />
                        Chemicals
                      </span>
                    </div>

                    <div className="flex items-center justify-center gap-2">
                      <span className="text-pink-500 text-lg">🐰</span>
                      <span className="text-sm leading-tight text-gray-800 dark:text-white">
                        Cruelty
                        <br />
                        Free
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



        {/* PRODUCTS */}
        <section id="products" className="max-w-6xl mx-auto py-16 px-4">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-10 text-pink-600 dark:text-pink-300">
            Our Bestsellers
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {BESTSELLERS.map((item) => {
              const qty = qtyInCart(item.id);
              const fav = favorites.includes(item.id);
              const stock = item.stock;

              return (
                <div key={item.id} className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 text-center">
                  <img src={item.img} alt={item.name} className="h-48 w-full object-cover rounded-xl mb-4" />
                  <h4 className="text-xl font-semibold mb-2">{item.name}</h4>
                  <p className="text-gray-700 dark:text-gray-300 mb-1">₹{item.price}</p>
                  <p className={`font-semibold mb-3 ${stock > 5 ? "text-green-600" : stock > 0 ? "text-yellow-500" : "text-red-500"}`}>
                    {stock > 5 ? "In Stock" : stock > 0 ? `Only ${stock} left` : "Out of Stock"}
                  </p>
                  <button
                    onClick={() => openModal(item)}
                    className="px-4 py-2 bg-pink-500 text-white rounded-xl hover:bg-pink-600 transition"
                  >
                    View More
                  </button>
                </div>
              );
            })}
          </div>
        </section>

        {/* PRODUCT MODAL */}
        {/* PRODUCT MODAL */}
        {modalOpen && selectedProduct && (
          <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
            onClick={closeModal}
          >
            <div
              className="bg-white dark:bg-gray-800 rounded-2xl p-6 pt-16 max-w-md w-full relative shadow-lg"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 dark:hover:text-gray-200 text-xl bg-white dark:bg-gray-800 rounded-full p-1 shadow"
              >
                ✕
              </button>

              {/* Image */}
              <img
                src={selectedProduct.img}
                alt={selectedProduct.name}
                className="h-48 w-full object-cover rounded-xl mb-4"
              />

              {/* Name */}
              <h4 className="text-2xl font-bold mb-2">{selectedProduct.name}</h4>

              {/* Price + Measurement same line */}
              <div className="flex items-center justify-between mb-2 text-gray-700 dark:text-gray-300 px-1">
                <p className="font-semibold text-lg">₹{selectedProduct.price}</p>
                {selectedProduct.unit && (
                  <p className="text-sm opacity-80 pr-2">{selectedProduct.unit}</p>
                )}
              </div>


              {/* Short Description */}
              <p className="mb-3 text-gray-700 dark:text-gray-300">
                {selectedProduct.description || "No description available."}
              </p>

              {/* Long Description */}
              {selectedProduct.longDescription && (
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-4 leading-relaxed whitespace-pre-line">
                  {selectedProduct.longDescription}
                </p>
              )}

              {/* Fav + Cart Row */}
              <div className="flex justify-between items-center mb-3">
                {/* Favorite Icon */}
                <button
                  onClick={() => toggleFavorite(selectedProduct.id)}
                  className="p-3 rounded-full bg-gray-100 dark:bg-gray-700"
                >
                  {favorites.includes(selectedProduct.id) ? (
                    <Heart className="text-red-500 fill-red-500" size={20} />
                  ) : (
                    <Heart className="text-gray-500" size={20} />
                  )}
                </button>

                {/* Add to Cart / Qty Controls */}
                <div>
                  {qtyInCart(selectedProduct.id) > 0 ? (
                    <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-full max-w-fit">
                      <button
                        onClick={() => handleDecrement(selectedProduct.id)}
                        className="px-2 py-1 rounded-md bg-gray-200 dark:bg-gray-800 text-sm"
                      >
                        −
                      </button>
                      <div className="px-3 text-sm font-medium">{qtyInCart(selectedProduct.id)}</div>
                      <button
                        onClick={() => handleIncrement(selectedProduct)}
                        className="px-2 py-1 rounded-md bg-pink-600 text-white text-sm"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <button
                      disabled={selectedProduct.stock === 0}
                      onClick={() => handleAdd(selectedProduct)}
                      className={`px-4 py-2 rounded-xl text-white text-sm transition max-w-fit ${
                        selectedProduct.stock === 0
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-pink-600 hover:bg-pink-700"
                      }`}
                    >
                      Add to Cart
                    </button>
                  )}
                </div>
              </div>

              {/* Go to Products Page */}
              <button
                onClick={() => {
                  navigate("/products");
                  closeModal();
                }}
                className="w-full px-4 py-3 mt-2 rounded-xl text-white bg-pink-600 hover:bg-pink-700 transition text-center"
              >
                Go to Products Page
              </button>
            </div>
          </div>
        )}

   

      {/* ===== Floating Cart Button — place this BEFORE the final closing </div></div> ===== */}
      {itemCount > 0 && (
        <button
          onClick={() => navigate("/cart")}
          className="
            fixed right-4 bottom-6 z-50
            flex items-center gap-2
            px-4 py-3 rounded-full
            bg-pink-600 hover:bg-pink-700
            text-white shadow-lg
            active:scale-95 transition
          "
        >
          {/* icon (SVG) — no extra imports needed) */}
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4" />
            <circle cx="10" cy="20" r="1" />
            <circle cx="18" cy="20" r="1" />
          </svg>

          <span className="hidden sm:inline font-medium">Cart</span>

          <span className="ml-2 bg-yellow-400 text-black text-xs px-2 rounded-full font-bold">
            {itemCount}
          </span>
        </button>
      )}



      </div>
    </div>
  );
}
